<template>
  <div class="tab-password">
    <div class="password-main-wrapper">
      <div class="member-header" style="display: none;">
        <h4>liyan</h4>
        <p>{{$t('widgets_basic_member_center_components_tab_password_2598')}}</p>
      </div>
      <div class="form-wrapper">
        <form>
          <div class="form-item form-item-required">
            <label class="my-label" for="" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_password_2599')}}</label>
            <input class="member-input" :style="$parent.contentStyle" type="text" :aria-placeholder="$t('widgets_basic_member_center_components_tab_password_2600')"
                   :placeholder="$t('widgets_basic_member_center_components_tab_password_2600')">
          </div>
          <div class="form-item form-item-required">
            <label class="my-label" for="" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_password_2601')}}</label>
            <input class="member-input" :style="$parent.contentStyle" type="text" :aria-placeholder="$t('widgets_basic_member_center_components_tab_password_2602')"
                   :placeholder="$t('widgets_basic_member_center_components_tab_password_2602')">
          </div>
          <div class="form-item form-item-required">
            <label class="my-label" for="" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_password_2603')}}</label>
            <input class="member-input" :style="$parent.contentStyle" type="text" :aria-placeholder="$t('widgets_basic_member_center_components_tab_password_2604')"
                   :placeholder="$t('widgets_basic_member_center_components_tab_password_2604')">
          </div>
          <div class="form-item form-item-btn">
            <span class="label-placeholder"></span>
            <button class="btn-confirm" type="button" @click="onClickConfirmBtn" :style="$parent.buttonStyle">{{$t('widgets_basic_member_center_components_tab_password_2605')}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_member_center_password.vue",
  methods: {
    onClickConfirmBtn() {
      this.$message.info(i18n.t('components_set_link_components_submit_form_index_2470'))
    },
  }
}
</script>

<style scoped lang="scss">
.tab-password, .password-main-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.password-main-wrapper {
  width: 100%;
}

.form-wrapper {
  width: 100%;
  max-width: 500px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .my-label {
    width: 5em;
    text-align: right;
  }

  &.form-item-required {
    .my-label:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .label-placeholder {
    width: 5em;
  }
}

.member-input {

}

.member-input {
  display: inline-block;
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: #F7F8FB;
  border-radius: 3px;
  padding-left: 10px;
  border: 1px solid transparent;
  outline: none;
  margin-left: 20px;

  &:hover {
    border-color: var(--theme_color);
  }

  &:focus {
    border-color: var(--theme_color);
  }
}

.btn-confirm {
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: var(--theme_color);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 20px;
}

input::-webkit-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input::-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-ms-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

.mb_pattern .tab-password {
  .password-main-wrapper {
    width: 53%;
    display: flex;
    justify-content: flex-end;
    padding-right: 5%;
  }

  .form-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-item-required .my-label:before {
    position: absolute;
    left: -10px;
  }

  .member-input {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }

  .label-placeholder {
    display: none;
  }

  .my-label {
    width: auto;
  }

  .member-input {
    background: transparent;
    border: none;
    border-bottom: 1px solid #b0b0b0;

    &:hover {
      border-bottom: 1px solid var(--theme_color);
    }

    &:focus {
      border-bottom: 1px solid var(--theme_color);
    }
  }

  .form-item-terms-content {
    width: 100%;
    padding-left: 0;
  }

  .btn-register, .btn-confirm {
    width: 100%;
    margin-left: 0;
  }

}

.mb_pattern .tab-password {
  .password-main-wrapper {
    width: 100%;
    order: 2;
    padding-left: 5%;
    padding-right: 5%;
  }

  .password-main-content {
    padding-left: 0;
    width: 100%;
  }

  .img-wrapper {
    width: 100%;
    order: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_center/components/tab-password.vue